import { useViewport } from '@doxyme/ui/hooks';
import { type ModalProps } from '@doxyme/ui/components/foundations';
import { type UpsellCardProps } from '../../../upgrade/upsellCard';

type UseStylesReturnType = {
  modalCSS: ModalProps['styles'];
  upsellCardImageSize: UpsellCardProps['imageSize'];
};

export const useInviteViaTextMessageFreeModalContentStyles =
  (): UseStylesReturnType => {
    const { isSmallViewport } = useViewport();

    return {
      modalCSS: {
        ...(!isSmallViewport && {
          submitButton: {
            flex: 'initial',
            minWidth: 'auto',
          },
        }),
      },
      upsellCardImageSize: isSmallViewport ? '150px' : '60%',
    };
  };
